import React, { useState, useEffect } from "react";
import { Box } from "@material-ui/core";
import moment from "moment";
import supabase from "../../supabase";
import { LoaderSpinner } from "../spinner/loader";
import { formatCurrency } from "../../utils/formatters";
import { formatDateForDisplay } from "../../utils/dateUtils";
import ChecksReportTable from "../checksReportTable";

const ChecksScreen = () => {
  const [checks, setChecks] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getChecks();
  }, []);

  const getChecks = async () => {
    setLoading(true);
    try {
      const { data: checksData, error } = await supabase
        .from("paymentDetails")
        .select(`
          *,
          checkEmitionDate:checkEmitionDate::text,
          checkPaymentDate:checkPaymentDate::text
        `)
        .eq("paymentMethod", 7)
        .order("checkEmitionDate", { ascending: false });

      if (error) throw error;

      const processedChecks = checksData.map(check => ({
        ...check,
        checkEmitionDate: formatDateForDisplay(check.checkEmitionDate),
        checkPaymentDate: formatDateForDisplay(check.checkPaymentDate),
        checkAmount: formatCurrency(check.checkAmount),
        checkState: getEstadoLabel(check.checkState)
      }));

      setChecks(processedChecks);
    } catch (error) {
      console.error("Error al obtener los cheques:", error);
    } finally {
      setLoading(false);
    }
  };

  const getEstadoLabel = (estado) => {
    const estados = {
      0: "Pendiente",
      1: "Cobrado",
      2: "Rechazado"
    };
    return estados[estado] || "Desconocido";
  };

  return loading ? (
    <div style={{
      width: "100%",
      height: "200px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}>
      <LoaderSpinner />
    </div>
  ) : (
    <Box className="order-details-form-container">
      <ChecksReportTable checks={checks} />
    </Box>
  );
};

export default ChecksScreen; 